<template>
    <div
        v-if="isVisible"
        :class="['alert', `alert-${color}`, dismissibleClass]"
        role="alert"
    >
        <slot></slot>
        <AppButton
            v-if="dismissible"
            type="button"
            btnClass="btn-close"
            aria-label="Close"
            @click="dismiss"
        />
    </div>
</template>

<script setup>
import { ref, watch, defineEmits } from "vue";
import AppButton from "@/vue/shared/AppButton.vue";

const props = defineProps({
    color: {
        type: String,
        default: "primary",
        validator: (value) => [
            "primary",
            "secondary",
            "success",
            "danger",
            "warning",
            "info",
            "light",
            "dark"
        ].includes(value)
    },
    visible: {
        type: Boolean,
        default: false
    },
    dismissible: {
        type: Boolean,
        default: false
    }
});

const isVisible = ref(props.visible);
const { emit } = defineEmits();

const dismiss = () => {
    isVisible.value = false;

    emit("close");
};

const dismissibleClass = props.dismissible ? "alert-dismissible" : "";

watch(() => props.visible, (newValue) => {
    isVisible.value = newValue;
});
</script>
